import React, { useEffect, useState } from "react"
import Typography from "@mui/material/Typography"
import { doc, getDoc, db, collection } from "../../service/firebase"
import { useNavigate, useParams } from "react-router-dom"
import useDeviceSize from "../../hooks/useDeviceSize.ts"
import OrderListCompact from "./OrderListCompact.tsx"
import { Divider, Skeleton, Stack } from "@mui/material"
import OrderList from "./OrderList.tsx"

const OrderPage = () => {
  const navigate = useNavigate()
  const { ownerId, storeId, orderId } = useParams()
  const [loading, setLoading] = useState(false)
  const [store, setStore] = useState({})
  const [order, setOrder] = useState({})
  const { mediumScreensUp } = useDeviceSize()
  useEffect(() => {
    setLoading(true)
    ;(async () => {
      const storesRef = await collection(
        db,
        `/StoreOwners/${ownerId}/allStores`,
      )
      const store = await getDoc(doc(storesRef, storeId))
      if (store.exists()) {
        let data = store.data()
        data.columnsList = JSON.parse(data.columnsList)
        setStore(data)
      }
      const orderRef = await collection(
        db,
        `/StoreOwners/${ownerId}/allStores/${storeId}/Orders`,
      )
      const order = await getDoc(doc(orderRef, orderId))
      if (order.exists()) {
        let orderData = order.data()
        orderData.order = JSON.parse(orderData.order)
        let temp = []
        orderData.order.forEach((p) => {
          if (p !== null) {
            if (p.quantity !== 0) {
              temp.push(p)
            }
          }
        })
        orderData.order = temp
        setOrder(orderData)
        setLoading(false)
      } else setLoading(false)
    })()
  }, [navigate, ownerId, storeId, orderId])

  if (loading) return <Skeleton variant="rectangular" height={500} />
  if (!order)
    return (
      <>
        <Typography gutterBottom variant="h4">
          Order information
        </Typography>
        <Typography gutterBottom variant="h6">
          No order could be found
        </Typography>
      </>
    )

  return (
    <>
      <Typography
        style={{ marginBottom: "20px", wordBreak: "break-all" }}
        variant="h4"
      >
        {store?.storeName}
      </Typography>

      <Typography style={{ wordBreak: "break-all" }} variant="h6">
        Order information
      </Typography>
      <Stack sx={{ mb: 3 }}>
        {order.name && (
          <Typography variant="body2">Name: {order.name}</Typography>
        )}
        {order.email && (
          <Typography variant="body2">Email: {order.email}</Typography>
        )}
        {order.phone && (
          <Typography variant="body2">Phone: {order.phone}</Typography>
        )}
        {order.createdAt && (
          <Typography variant="body2">
            Order placed:{" "}
            {new Date(order?.createdAt?.seconds * 1000).toLocaleDateString()}
          </Typography>
        )}
      </Stack>
      <Divider />
      {mediumScreensUp ? (
        <OrderList order={order} store={store} />
      ) : (
        <OrderListCompact order={order} store={store} />
      )}
    </>
  )
}

export default OrderPage
